import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {FormBuilder, FormGroup} from '@angular/forms';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {FormControl} from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import {Observable} from 'rxjs';
import {filter, map, startWith} from 'rxjs/operators';
import { MatCheckboxChange, MatCheckbox } from '@angular/material/checkbox';
import { BenefitsService } from 'src/app/services/api/benefits/benefits.service';
import { CategoriesComponent } from '../categories/categories.component';

@Component({
  selector: 'app-benefits-filter',
  templateUrl: './benefits-filter.component.html',
  styleUrls: ['./benefits-filter.component.scss']
})


export class BenefitsFilterComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() festividades: boolean = false;
  categoriesTag: FormGroup;
  modoDeUsoTag: FormGroup;
  diasTag: FormGroup;
  beneficiosTag: FormGroup;
  ordersTag: FormGroup;
  categories = [];
  fb: FormBuilder | undefined

  ordExpanded: boolean = false;
  catExpanded:boolean = false;
  mduExpanded: boolean = false;
  diaExpanded:boolean = false;
  benExpanded: boolean = false;

  categs: any  = [
    {id:51, 'Hot Sale': false, label: 'Hot Sale', url: 'hot-sale'},
    {id:24, 'Automóvil': false, label: 'Automóvil', url: 'automovil'},
    {id:21, 'Compras': false, label: 'Compras', url: 'compras'},
    {id:28, 'Cuidado Personal': false, label: 'Cuidado Personal', url: 'cuidado-personal'},
    {id:38, 'Entretenimiento': false, label: 'Entretenimiento', url: 'entretenimiento'},
    {id:20, 'Gastronomía': false, label: 'Gastronomía', url: 'gastronomia'},
    {id:35, 'Hogar': false, label: 'Hogar', url: 'hogar'},
    {id:34, 'Indumentaria': false, label: 'Indumentaria', url: 'indumentaria'},
    {id:37, 'Mascotas': false, label: 'Mascotas', url: 'mascotas'},
    {id:19, 'Tecnología': false, label: 'Tecnología', url: 'tecnologia'},
    {id:43, 'Turismo': false, label: 'Turismo', url: 'turismo'},
    {id:45, 'Supermercados': false, label: 'Supermercados', url: 'supermercados'},
    {id:46, 'Gaming': false, label: 'Gaming', url: 'gaming'},
    {id:47, 'Educación': false, label: 'Educación', url: 'educacion'},
    {id:49, 'Infantil': false, label: 'Infantil', url: 'infantil'},
  ]

  festividadesCategs: any[] = [
    { id: 21, name: 'Compras', label: 'Compras', url: 'compras' },
    { id: 28, name: 'Cuidado Personal', label: 'Cuidado Personal', url: 'cuidado-personal' },
    { id: 46, name: 'Gaming', label: 'Gaming', url: 'gaming' },
    { id: 34, name: 'Indumentaria', label: 'Indumentaria', url: 'indumentaria' },
    { id: 38, name: 'Infantil', label: 'Infantil', url: 'infantil' },
    { id: 19, name: 'Tecnología', label: 'Tecnología', url: 'tecnologia' },
  ];

  modoDeUso: any = [
    { id: 1, 'Presencial': false, label: 'Presencial', url: 'presencial' },
    { id: 2, 'Online': false, label: 'Online', url: 'online' }
  ];

  dias: any = [{'Todos los días': false, label: 'Todos los días', url: 'todos-los-dias'},{id: 7, 'Domingo': false, label: 'Domingo', url: 'domingo'}, {id: 1, 'Lunes': false, label: 'Lunes', url: 'lunes'}, {id: 2, 'Martes': false, label: 'Martes', url: 'martes'}, {id: 3, 'Miércoles': false, label: 'Miércoles', url: 'miercoles'}, {id: 4, 'Jueves': false, label: 'Jueves', url: 'jueves'}, {id: 5, 'Viernes': false, label: 'Viernes', url: 'viernes'}, {id: 6, 'Sábado': false, label: 'Sábado', url: 'sabado'}]

  beneficios: any = [{id: 1, '% de Descuento': false, label: '% de Descuento', url: 'porcentaje-de-descuento'}, {id: 2, 'Monto de Descuento/Regalo': false, label: 'Monto de Descuento/Regalo', url: 'monto-de-descuento-regalo'}]

  orders: any = [{id: 1, 'Más Cercanos':false, label: 'Más Cercanos', url: 'mas-cercanos'}, {id: 2, 'Mayor Descuento': false, label: 'Mayor Descuento', url: 'mayor-descuento' }, {id: 3, 'Más Recientes': false, label: 'Más Recientes', url: 'mas-recientes'}, {id: 4, 'A-Z': false, label: 'A-Z', url: 'a-z'}, {id: 5, 'Z-A': false, label: 'Z-A', url: 'z-a'}]
  panelOpenState = false;

  arrayFiltros: string[] = [];

  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  filterCtrl = new FormControl();
  filteredItems: Observable<string[]>;
  filterSelected: string[] = []
  allFilters: string[] = []

  intervalo:any;


  cat_data = this.benefitService.data_category;
  modo_data = this.benefitService.data_modoUso;
  benef_data = this.benefitService.data_tipoBeneficio;
  dias_data = this.benefitService.data_diasValidez;
  orden_data = this.benefitService.data_ordenamiento;

  filterUrl = this.benefitService.url_filters;
  expandedCategory: string | null = null;
  selectedCategoriesCount: number = 0;
  filteredDias = this.dias.filter((d: { label: string; }) => d.label !== 'Todos los días');
  @Output() closeFilter = new EventEmitter<void>();
  @Output() filtersUsed = new EventEmitter<number>();
  isMobile: boolean = window.innerWidth <= 1000;

  @Output()
  change: EventEmitter<MatCheckboxChange> | undefined
  @ViewChild('filterInput') filterInput: ElementRef<HTMLInputElement> | undefined;
  selectedFilters: any;
  routeParamsSubscription: any;

  ngOnDestroy(): void {
    if (this.routeParamsSubscription) {
      this.routeParamsSubscription.unsubscribe();
    }
    const href = window.location.href;  
    if (!href.includes('/beneficios-y-descuentos')) {
    // Limpiar los filtros del componente
    this.filterUrl = [];
    this.filterSelected = [];
    // Limpiar los arrays del servicio
    this.benefitService.data_category = [];
    this.benefitService.data_modoUso = [];
    this.benefitService.data_diasValidez = [];
    this.benefitService.data_tipoBeneficio = [];
    this.benefitService.url_filters = [];
    this.benefitService.clearFilters();

    }
    // Limpiar el intervalo
    if (this.intervalo) {
      clearInterval(this.intervalo);
    }
  }

  constructor(
    fb: FormBuilder,
    private benefitService : BenefitsService,
    private categoryService : CategoriesComponent,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.readUrlParams();
    //this.getCategories();
    this.ordersTag = fb.group(this.orders.reduce((a: any, v: any) => ({ ...a, [v.label]: v[v.label]}), {}));
    this.filteredItems = this.filterCtrl.valueChanges.pipe(
      startWith(null),
      map((filter: string | null) => filter ? this._filter(filter) : this.allFilters.slice()));
      this.filterUrl = this.benefitService.url_filters;
      this.categoriesTag = fb.group(this.categs.reduce((a: any, v: any) => ({ ...a, [v.label]: v[v.label]}), {}));

    this.modoDeUsoTag = fb.group(this.modoDeUso.reduce((a: any, v: any) => ({ ...a, [v.label]: v[v.label]}), {}));
    this.diasTag = fb.group(this.dias.reduce((a: any, v: any) => ({ ...a, [v.label]: v[v.label]}), {}));
    this.beneficiosTag = fb.group(this.beneficios.reduce((a: any, v: any) => ({ ...a, [v.label]: v[v.label]}), {}));
    this.ordersTag = fb.group(this.orders.reduce((a: any, v: any) => ({ ...a, [v.label]: v[v.label]}), {}));

    this.filterUrl = this.benefitService.url_filters;
  }
  
  get selectedModoDeUsoCount(): number {
    return Object.values(this.modoDeUsoTag.value).filter(v => v).length;
  }

  
  get selectedBeneficiosCount(): number {
    return Object.values(this.beneficiosTag.value).filter(v => v).length;
  }

  get selectedDaysCount(): number {
    if (this.diasTag.get('Todos los días')?.value) {
      Object.keys(this.diasTag.controls).forEach(key => {
        this.diasTag.controls[key].setValue(true);
        console.log(this.diasTag.get('Todos los días')?.value);
      });
      const todosLosDiasLabel = 'Todos los días';
      this.filterSelected.push(todosLosDiasLabel);
      return this.dias.length - 1;
    }
    
    return Object.entries(this.diasTag.controls)
      .filter(([key, control]) => {
        if (key === 'Todos los días') return false;
        return control.value === true;
      })
      .length;
  }

  ngAfterViewInit(): void {
    if(this.filterSelected.length == 1 && this.filterSelected[0] != "Más Recientes"){
      this.scroll("filtros")
    }else if(this.filterSelected.length >= 2){
      this.scroll("filtros")
    }
  }

  ngOnInit(): void {
    this.categs = this.festividades ? this.festividadesCategs : this.categs;
    const hideDate = new Date('2025-05-18T23:59:00');
    const now = new Date();
    if (now >= hideDate) {
      this.categs = this.categs.filter((cat: { id: number; }) => cat.id !== 51);
    }

    this.filteredDias = this.filteredDias.filter(
      (dia: { label: any; }, index: any, self: any[]) => index === self.findIndex((d: { label: any; }) => d.label === dia.label)
    );
  }


  updateFiltersCount() {
    const usedFilters = this.selectedModoDeUsoCount + this.selectedBeneficiosCount + this.selectedDaysCount + this.selectedCategoriesCount;
    this.filtersUsed.emit(usedFilters);
  }

  toggleCategory(category: string): void {
    this.expandedCategory = this.expandedCategory === category ? null : category;
  }
  
  scroll(id: string) {
    let el = document.getElementById(id);

    if(el != null){
      el.scrollIntoView();
    }
  }

   addOrden(event: MatCheckboxChange | any): void {
    const selected = this.filterSelected;

    const value = this.ordersTag.value;
    const valueArray = Object.entries(value);
    const filtered = valueArray.filter(([key, value]) => value == true);
    const falseFiltered = valueArray.filter(([key, value]) => value == false);

    // Add our filter
    filtered.forEach((orden, i)=>{
      if( !selected.includes(orden[0]) ){
        var urlFilter = this.getUrlName(orden[0])

        this.filterUrl.push(urlFilter)
        selected.push(orden[0])

        this.setearIntervalo(this.filterUrl)
      }
    })
    // Remove our filter
    falseFiltered.forEach((orden, i)=>{

      if( selected.includes(orden[0]) ){
        var index = selected.indexOf(orden[0]);

        if (index !== -1) {
       this.filterUrl.splice(index);
      }

        this.setearIntervalo(this.filterUrl)
      }
    })

    this.filterCtrl.setValue(null);
  }

  selectOrder(event: any){

    this.orders.forEach((item:any, i:any)=>{
      if(this.filterUrl.includes(item.url)){
        var newFilter = this.filterUrl.filter(e => e !== item.url);

        this.filterUrl = newFilter
      }

      if(event.target.value == item.id){
        this.orden_data = item.id
        this.filterUrl.push(item.url)

        setTimeout(()=>{
          this.benefitService.filter_benefits(this.filterUrl);
        }, 3000);
      }

    });
  }

  toggleMenu() {
    this.closeFilter.emit();
  }
  

  clearFilters(): void {
    this.categoriesTag.reset();
    this.modoDeUsoTag.reset();
    this.beneficiosTag.reset();
    this.diasTag.reset();
  
    this.filterUrl = [];
    this.filterSelected = [];
  
    this.updateFilters({}, this.categoriesTag);
    this.updateFilters({}, this.modoDeUsoTag);
    this.updateFilters({}, this.beneficiosTag);
    this.updateFilters({}, this.diasTag);
    this.router.navigate(['/beneficios-y-descuentos']);
  }
  

  toggleTodosLosDias(event: any): void {
    const checked = event.target.checked;
    const todosLosDiasLabel = 'Todos los días';
    const todosLosDiasUrl = this.getUrlName(todosLosDiasLabel);

    // Actualizar el estado de todos los checkboxes
    Object.keys(this.diasTag.controls).forEach(key => {
      this.diasTag.controls[key].setValue(checked);
    });

    if (checked) {
      if (!this.filterSelected.includes(todosLosDiasLabel)) {
        this.filterSelected.push(todosLosDiasLabel);
        this.filterUrl.push(todosLosDiasUrl);
      }

      this.dias_data = [...this.dias]; // Copia todos los días
      this.benefitService.data_diasValidez = [...this.dias_data];
    } else {
      const index = this.filterSelected.indexOf(todosLosDiasLabel);
      if (index !== -1) {
        this.filterSelected.splice(index, 1);
      
      const urlIndex = this.filterUrl.indexOf(todosLosDiasUrl);
      if (urlIndex !== -1) {
        this.filterUrl.splice(urlIndex, 1);
      }
    }
    
    this.dias_data = [];
    this.benefitService.data_diasValidez = [];
    }

    this.setearIntervalo(this.filterUrl);
  }

  get selectedDiasCount(): number {
    return Object.values(this.diasTag.value).filter(v => v).length;
  }  

  setearIntervalo(filterUrl: string[]): void {
    if (this.intervalo !== undefined) {
      clearInterval(this.intervalo);
    }
    
    this.intervalo = setInterval(() => {
      if (this.festividades) {
        this.benefitService.filterCategories(filterUrl);
      } else {
        this.benefitService.filter_benefits(filterUrl);
      }
    }, 1000);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.allFilters.filter(filter => filter.toLowerCase().includes(filterValue));
  }

  applyFilters(): void {
    this.updateFilters(this.categoriesTag.value, this.categoriesTag);
    this.updateFilters(this.modoDeUsoTag.value, this.modoDeUsoTag);
    this.updateFilters(this.beneficiosTag.value, this.beneficiosTag);
  }  

  private updateFilters(value: any, filterGroup: FormGroup): void {
    const selected = this.filterSelected;
    
  
    Object.entries(value).forEach(([key, val]) => {
      const index = this.filterUrl.indexOf(this.getUrlName(key));
      if (val) {
        if (index === -1) {
          this.filterUrl.push(this.getUrlName(key));
          selected.push(key);
        }
      } else {
        if (index !== -1) {
          this.filterUrl.splice(index, 1);
          selected.splice(selected.indexOf(key), 1);
        }
      }
    });
  
    if (this.festividades) {
      this.benefitService.filterCategories(this.filterUrl);
    } else {
      this.benefitService.filter_benefits(this.filterUrl);
    }
  }

  async getCategories(){
    return await this.categoryService.getAll().toPromise()
    .then((response: any) => {
      this.categories = response.sort((a: any) => (a.stared ? -1 : 1));
    });
  }


  getUrlName(filter: string){
    var filter_name = filter.replace(/ /g, '-');
    filter_name = filter_name.replace(/\//g, '-');
    filter_name = filter_name.replace("%", 'porcentaje');
    filter_name = filter_name.toLowerCase();
    filter_name = filter_name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return filter_name;
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.filterSelected.push(event.option.viewValue);
    this.filterCtrl.setValue(null);
  }

  addModoUso(event: MatCheckboxChange | any): void {
    const value = this.modoDeUsoTag.value;
    this.updateFilters(value, this.modoDeUsoTag);    
  }

  addBeneficios(event:MatCheckboxChange | any): void {
    const selected = this.filterSelected;
    const value = this.beneficiosTag.value;
    const valueArray = Object.entries(value);
    const filtered = valueArray.filter(([key, value]) => value == true);
    const falseFiltered = valueArray.filter(([key, value]) => value == false);

    // Add our filter
    filtered.forEach((beneficio, i)=>{
      if( !selected.includes(beneficio[0]) ){
        var urlFilter = this.getUrlName(beneficio[0])

        this.filterUrl.push(urlFilter)
        selected.push(beneficio[0])

        this.setearIntervalo(this.filterUrl)
      }
    })

    // Remove our filter
    falseFiltered.forEach((beneficio, i)=>{
      if( selected.includes(beneficio[0]) ){
        const urlFilter = this.getUrlName(beneficio[0]);
        // Remover del array filterUrl usando el filtro correcto
        const urlIndex = this.filterUrl.indexOf(urlFilter);
        if (urlIndex !== -1) {
          this.filterUrl.splice(urlIndex, 1);
        }
        // Remover del array selected
        const selectedIndex = selected.indexOf(beneficio[0]);
        if (selectedIndex !== -1) {
          selected.splice(selectedIndex, 1);
        }
      }
    })

    // Llamar setearIntervalo solo si hubo removidos
    if (falseFiltered.length > 0) {
      this.setearIntervalo(this.filterUrl);
    }
  }


  addDays(event: Event | MatCheckboxChange, diaLabel: string): void {
    let isChecked: boolean;
    
    if ('checked' in event) {
      isChecked = event.checked;
    } else if (event.target) {
      isChecked = (event.target as HTMLInputElement).checked;
    } else {
      console.error('No se pudo determinar el estado del checkbox');
      return;
    }
    
    if (!diaLabel) {
      return;
    }
    
    const urlFilter = this.getUrlName(diaLabel);
    
    if (isChecked) {
      if (!this.filterSelected.includes(diaLabel)) {
        this.filterSelected.push(diaLabel);
        this.filterUrl.push(urlFilter);
        
        // Agregar al array de días seleccionados en el servicio
        const dia = this.dias.find((d: any) => d.label === diaLabel);
        if (dia) {
          this.dias_data.push(dia);
          this.benefitService.data_diasValidez = [...this.dias_data];
        }
      }
    } else {
      // Remover el día si está seleccionado
      const index = this.filterSelected.indexOf(diaLabel);
      if (index !== -1) {
        this.filterSelected.splice(index, 1);
        
        // Remover de la URL de filtros
        const urlIndex = this.filterUrl.indexOf(urlFilter);
        if (urlIndex !== -1) {
          this.filterUrl.splice(urlIndex, 1);
        }
        
        // Remover del array de días seleccionados en el servicio
        this.dias_data = this.dias_data.filter((d: any) => d.label !== diaLabel);
        this.benefitService.data_diasValidez = [...this.dias_data];
      }
    }
    
    // Actualizar el intervalo para aplicar los filtros
    this.setearIntervalo(this.filterUrl);
  }


  addCategories(event:MatCheckboxChange | any): void {
    const selected = this.filterSelected;

    const value = this.categoriesTag.value;
    const valueArray = Object.entries(value);
    const selectedCategory = Object.values(this.categoriesTag.value).filter(value => value);
    this.selectedCategoriesCount = selectedCategory.length;
  
    const filtered = valueArray.filter(([key, value]) => value === true);
    const falseFiltered = valueArray.filter(([key, value]) => value === false);

    filtered.forEach(([categoryLabel]) => {
      if (!selected.includes(categoryLabel)) {
        const urlFilter = this.getUrlName(categoryLabel);
        this.filterUrl.push(urlFilter);
        selected.push(categoryLabel);
  
        this.setearIntervalo(this.filterUrl);
      }
    });


    falseFiltered.forEach(([categoryLabel]) => {
      // Get the URL filter for this category
      const urlFilter = this.getUrlName(categoryLabel);
      
      // Remove from selected array
      const selectedIndex = selected.indexOf(categoryLabel);
      if (selectedIndex !== -1) {
        selected.splice(selectedIndex, 1);
      }
      
      // Remove from filterUrl array
      const filterUrlIndex = this.filterUrl.indexOf(urlFilter);
      if (filterUrlIndex !== -1) {
        this.filterUrl.splice(filterUrlIndex, 1);
      }
    });
    
    // Only call setearIntervalo once after all removals
    if (falseFiltered.length > 0) {
      this.setearIntervalo(this.filterUrl);
    }
    this.filterCtrl.setValue(null);
  }



  readUrlParams() {
    // Usar subscribe para detectar cambios en los parámetros de la ruta
    this.routeParamsSubscription = this.activatedRoute.params.subscribe(params => {
      const category = params['category'];
      
      // Limpiar estados previos
      this.filterSelected = [];
      this.cat_data = [];
      this.modo_data = [];
      this.dias_data = [];
      this.benef_data = [];
      this.orden_data = 3; // Valor por defecto para 'Más Recientes'
      
      // Resetear estados de los checkboxes
      this.categs.forEach((item: any) => item[item.label] = false);
      this.modoDeUso.forEach((item: any) => item[item.label] = false);
      this.dias.forEach((item: any) => item[item.label] = false);
      this.beneficios.forEach((item: any) => item[item.label] = false);
      this.orders.forEach((item: any) => item[item.label] = false);
      
      const selected = this.filterSelected;
      const url = this.filterUrl;

      if (category) {

      this.categs.forEach((item:any, i:any )=>{
        if(category.includes(item.url)){
          this.cat_data.push(item.id);
          this.categs[i][item.label] = true
          if(!url.includes(this.categs[i].url)){
            url.push(this.categs[i].url)
          }
          selected.push(this.categs[i].label)

          this.catExpanded = true
        }
      });
      
      this.modoDeUso.forEach((item:any, i:any )=>{
        if(category.includes(item.url)){
          this.modo_data.push(item.id);
          this.modoDeUso[i][item.label] = true
          if(!url.includes(this.modoDeUso[i].url)){
            url.push(this.modoDeUso[i].url)
          }
          selected.push(this.modoDeUso[i].label)

          this.mduExpanded = true
        }
      });

      this.dias.forEach((item:any, i:any )=>{

        if(category.includes('todos-los-dias')){
          if(item.id != undefined){
            this.dias_data.push(item.id);
          }
        }else if(category.includes(item.url)){
          this.dias_data.push(item.id);
          this.dias[i][item.label] = true
          if(!url.includes(this.dias[i].url)){
            url.push(this.dias[i].url)
          }
          selected.push(this.dias[i].label)

          this.diaExpanded = true
        }
      });

      if(category.includes('todos-los-dias')){
        this.dias[0][this.dias[0].label] = true
        if(!url.includes(this.dias[0].url)){
          url.push(this.dias[0].url)
        }
        selected.push(this.dias[0].label)

        this.diaExpanded = true
      }

      this.beneficios.forEach((item:any, i:any )=>{
        if(category.includes(item.url)){
          this.benef_data.push(item.id);
          this.beneficios[i][item.label] = true
          if(!url.includes(this.beneficios[i].url)){
            url.push(this.beneficios[i].url)
          }
          selected.push(this.beneficios[i].label)

          this.benExpanded = true
        }
      });

      this.orders.forEach((item:any, i:any )=>{
        if(category.includes(item.url)){
          this.orden_data = item.id;
          this.orders[i][item.label] = true
          if(!url.includes(this.orders[i].url)){
            url.push(this.orders[i].url)
          }
          selected.push(this.orders[i].label)

          this.ordExpanded = true
        }
      });
      } else {
        this.filterSelected.push('Más Recientes');
      }
      
      // Actualizar la URL con los filtros actuales
      this.benefitService.url_filters = url;
      this.benefitService.data_category = this.cat_data;
      this.benefitService.data_modoUso = this.modo_data;
      this.benefitService.data_tipoBeneficio = this.benef_data;
      this.benefitService.data_diasValidez = this.dias_data;
      this.benefitService.data_ordenamiento = this.orden_data;
    });
  }
}

